// @flow
import type { AdAccount, ImportError } from '../../../components/AgencyPage'

type State = {|
  adAccountsList: Array<AdAccount>,
  vkLoadedAccountsList: Array<Object>,
  reloadErrors: Array<string>,
  importErrors: Array<ImportError>,
  isModalOpen: boolean,
  isLoading: boolean
|}

type PatchAction = {|
  +type: 'AGENCY_PAGE.PATCH',
  +state: $Shape<State>
|}

type InitAction = {|
  +type: 'AGENCY_PAGE.INIT',
  +state: State
|}

type Action = PatchAction | InitAction

export type { State }

const initialState: State = {
  adAccountsList: [],
  vkLoadedAccountsList: [],
  reloadErrors: [],
  importErrors: [],
  isModalOpen: false,
  isLoading: false
}

export function patch(diff: $Shape<State>): Action {
  return {
    type: 'AGENCY_PAGE.PATCH',
    state: diff
  }
}

export function init(state: State): Action {
  return {
    type: 'AGENCY_PAGE.INIT',
    state
  }
}

function fromInitial(initial: State): State {
  return {
    adAccountsList: initial.adAccountsList || [],
    vkLoadedAccountsList: initial.vkLoadedAccountsList || [],
    reloadErrors: [],
    importErrors: [],
    isModalOpen: false,
    isLoading: false
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'AGENCY_PAGE.INIT':
      return fromInitial(action.state)
    case 'AGENCY_PAGE.PATCH':
      return { ...state, ...action.state }
    default:
      return state
  }
}
